<h2 mat-dialog-title class="text-primary">Activate Employee</h2>
<div class="row margin-adjust">
  <div class="col-6 cursor-pointer" (click)="setNormalActivation(false)">
    <div [ngClass]="!isRehireActivation ? 'activeHighlighted' : ''" class="d-flex align-items-center p-3 border flex-column">
      <i style="font-size: 40px" class="fa fa-check-circle fa-lg icn mb-3" aria-hidden="true"></i>
      <h5><b>Normal Activation</b></h5>
      <h6>Activate the profile for a new hire</h6>
    </div>
  </div>
  <div class="col-6 cursor-pointer" (click)="setNormalActivation(true)">
    <div [ngClass]="isRehireActivation ? 'activeHighlighted' : ''"  class="d-flex align-items-center p-3 border flex-column">
      <i style="font-size: 40px" class="fa fa-handshake-o fa-lg icn mb-3" aria-hidden="true"></i>
      <h5><b>Rehire</b></h5>
      <h6>Restore access and details for a returning employee</h6>
    </div>
  </div>
</div>
<mat-dialog-content>
  <div class="mt-3 d-flex flex-column align-items-center">
    <h4 mat-dialog-title class="text-primary mb-0 text-center">{{dateText}}</h4>
    <mat-form-field appearance="fill" class="w-50">
      <input matInput [matDatepicker]="picker" placeholder="Select Date" [formControl]="activationDateControl" [max]="maxDate" readonly />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="activationDateControl.hasError('required')">
        Please select a date
      </mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="d-flex w-100 align-items-center justify-content-center">
    <button mat-button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
    <button mat-button class="btn btn-primary" (click)="onSubmit()" [disabled]="activationDateControl.invalid">
      Proceed
    </button>
  </div> 
</mat-dialog-actions>